// =====================================
//
//   選擇常用地址 Modal
//   Author: Gray
//   createtime: 2016 / 03 / 08
//   updatetime: 2016 / 03 / 08
//
// =====================================

window.InifECApp.directive('selectAddress', ['$rootScope', '$stateParams', '$timeout', '$ngModal', 'UserService',
    function($rootScope, $stateParams, $timeout, $ngModal, UserService) {

        var _dir = {};

        var controller = ['$scope', function($scope) {

            // --------------------------------
            // [private] 取得會員的常用地址列表
            // --------------------------------
            var qyFavoriteAddress = function() {

                $scope.isLoading = true;

                UserService.qyFavoriteAddress().then(function(result) {

                    if(Array.isArray(result) && result.length > 0){
                        $scope.addressList = result;
                    } else if($scope.addressList.length == 0) {
                        $scope.isEmpty = true;
                    }

                    $scope.isLoading = false;

                }, function(error) {

                    $scope.isError = true;
                    $scope.isLoading = false;
                })
            }

            // --------------------------------
            // 選擇地址
            // --------------------------------
            var selectAddress = function(address) {

                ($scope.callback) && $scope.callback(address);
                closeModal();
            }

            // --------------------------------
            // [private] 打開 Modal
            // --------------------------------
            var openModal = function() {

                $ngModal.openModal('select-address-modal');
            }

            // --------------------------------
            // [private] 關閉 Modal
            // --------------------------------
            var closeModal = function() {

                $ngModal.closeModal('select-address-modal');
            }

            var init = function() {

            }

            /*==========================
                Events
            ==========================*/

            $scope.$on("OPEN_SELECT_ADDRESS_MODAL", function(event, data) {

                if(data) {
                    $scope.callback = data.callback;

                    qyFavoriteAddress();
                    openModal();
                }
            });
                
            /*==========================
                Members
            ==========================*/
            $scope.isEdit = false;
            $scope.isLoading = false;

            $scope.addressList = [];

            /*==========================
                Methods
            ==========================*/
            $scope.callback = undefined;
            $scope.selectAddress = selectAddress; // 選擇地址

            /*==========================
                init
            ==========================*/

            init();

        }]

        _dir.restrict = 'E';
        _dir.scope = true;
        _dir.templateUrl = 'partials/modal/select_address.html';
        _dir.controller = controller;

        return _dir;
}]);